<template>
  <div class="input">
    <div class="input-label">メールアドレス</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="email">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    placeholderEmail: function () {
      if (this.$route.name == 'user-new') {
        return 'メールは必須です。'
      }
      return ''
    },

    email: {
      get: function () {
        return this.$store.state.user.email
      },
      set: function (value) {
        this.$store.commit(
          'user/setEmail',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
